import React, { useState, useEffect } from "react";
import NutritionReport from "./Nutrition/NutritionReport";
import EconomyReport from "./Economy/EconomyReport";
import EnvironmentReport from "./Environment/EnvironmentReport";

const months = [
  "January",
  "Febuary",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const LastMonth = ({ inventory, trash, languageData }) => {
  const [loaded, setLoaded] = useState(false);
  const [itemsFromLastMonth, setItemsFromLastMonth] = useState("");
  let currentMonth = new Date().getMonth();

  const getItemsFromLastMonth = () => {
    let tempListOfItems = [];

    inventory.forEach((item) => {
      let itemsDate = new Date(item.dates[item.dates.length - 1]);

      if (currentMonth === itemsDate.getMonth()) {
        tempListOfItems.push(item);
      }
    });

    trash.forEach((item) => {
      let trashItemDate = new Date(item.dates[item.dates.length - 1]);
      if (currentMonth === trashItemDate.getMonth()) {
        tempListOfItems.push(item);
      }
    });

    setItemsFromLastMonth(tempListOfItems);
  };

  useEffect(() => {
    if (itemsFromLastMonth !== "") {
      setLoaded(true);
    }
  }, [itemsFromLastMonth]);

  useEffect(() => {
    getItemsFromLastMonth();
  }, []);

  return (
    <div className="reportBody">
      <h4 className="reportTitle" id="reportMonthlyTitle">
        Last Month
      </h4>
      <h6 id="reportMonth">{languageData["monthsLong"][currentMonth]}</h6>
      {!loaded ? (
        <p>Loading....</p>
      ) : (
        <React.Fragment>
          {" "}
          <EconomyReport
            list={itemsFromLastMonth}
            languageData={languageData}
          />
          <NutritionReport
            list={itemsFromLastMonth}
            languageData={languageData}
          />
          <EnvironmentReport
            list={itemsFromLastMonth}
            languageData={languageData}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default LastMonth;
